export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 mb-4">
          Ready to Shop Smarter?
        </h2>
        <p className="text-foreground-500 text-base md:text-lg mb-8 max-w-lg mx-auto leading-relaxed">
          Browse the full AcBuy Spreadsheet on our main site. Thousands of curated products, daily updates, and trusted shopping resources await.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer"
        >
          Buy It Now
          <i className="ri-arrow-right-line"></i>
        </a>

        <div className="mt-12 max-w-3xl mx-auto">
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 opacity-60">
            {[
              'https://readdy.ai/api/search-image?query=A%20single%20designer%20sneaker%20on%20a%20concrete%20surface%2C%20dramatic%20low%20angle%2C%20moody%20lighting%2C%20editorial%20fashion%20photography%2C%20rich%20texture%20details&width=120&height=80&seq=cta-prod-v3-1&orientation=landscape',
              'https://readdy.ai/api/search-image?query=Luxury%20leather%20handbag%20on%20a%20marble%20countertop%2C%20soft%20spotlight%2C%20boutique%20display%20aesthetic%2C%20elegant%20shadows%2C%20warm%20ambient%20tones&width=120&height=80&seq=cta-prod-v3-2&orientation=landscape',
              'https://readdy.ai/api/search-image?query=Premium%20watch%20with%20leather%20strap%20on%20a%20wooden%20desk%20beside%20a%20coffee%20cup%2C%20morning%20light%2C%20lifestyle%20photography%2C%20warm%20cozy%20vibe&width=120&height=80&seq=cta-prod-v3-3&orientation=landscape',
              'https://readdy.ai/api/search-image?query=Stylish%20sunglasses%20on%20a%20textured%20linen%20fabric%2C%20bright%20sunlight%2C%20summer%20fashion%20vibe%2C%20minimal%20composition%2C%20warm%20golden%20hour%20glow&width=120&height=80&seq=cta-prod-v3-4&orientation=landscape',
              'https://readdy.ai/api/search-image?query=Elegant%20scarf%20draped%20over%20a%20chair%20in%20a%20sunlit%20room%2C%20soft%20natural%20lighting%2C%20cozy%20interior%2C%20textile%20texture%20visible%2C%20warm%20neutral%20palette&width=120&height=80&seq=cta-prod-v3-5&orientation=landscape',
            ].map((src, i) => (
              <div key={i} className="w-20 h-14 md:w-24 md:h-16 rounded-md overflow-hidden bg-background-100">
                <img
                  src={src}
                  alt="AcBuy Spreadsheet product"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}